// // // // components/Navbar.jsx
// // // import React from "react";
// // // import { colors } from "../Color";
// // // import logo from "../image/"; // Adjust path if needed

// // // export default function Navbar({ onNavigate }) {
// // //   return (
// // //     <nav
// // //       className="flex justify-between items-center px-6 py-4 sticky top-0 z-50"
// // //       style={{ backgroundColor: colors.primary }}
// // //     >
// // //       <img src={logo} alt="Hexa Logo" className="h-8 w-auto" />
// // //       <h1
// // //         className="text-white font-bold text-xl cursor-pointer"
// // //         onClick={onNavigate.about}
// // //       >
// // //         HEXA ELECTRONICS
// // //       </h1>
// // //       <ul className="flex gap-6 text-white">
// // //         <li className="cursor-pointer" onClick={onNavigate.about}>
// // //           About
// // //         </li>
// // //         <li className="cursor-pointer" onClick={onNavigate.products}>
// // //           Products
// // //         </li>
// // //         <li className="cursor-pointer" onClick={onNavigate.services}>
// // //           Services
// // //         </li>
// // //         <li className="cursor-pointer" onClick={onNavigate.contact}>
// // //           Contact
// // //         </li>
// // //       </ul>
// // //     </nav>
// // //   );
// // // }

// // import React from "react";
// // import { colors } from "../Color";
// // import logo from "../image/logo.jpg"; // ✅ Update this to your actual logo file

// // export default function Navbar({ onNavigate }) {
// //   return (
// //     <nav
// //       className="flex justify-between items-center px-6 py-4 sticky top-0 z-50"
// //       style={{ backgroundColor: colors.primary }}
// //     >
// //       <div
// //         className="flex items-center gap-3 cursor-pointer"
// //         onClick={onNavigate.about}
// //       >
// //         <img src={logo} alt="Hexa Logo" className="h-12 w-auto" />
// //         {/* <h1 className="text-white font-bold text-xl">HEXA ELECTRONICS</h1> */}
// //       </div>

// //       <ul className="flex gap-6 text-white">
// //         <li className="cursor-pointer" onClick={onNavigate.about}>
// //           About
// //         </li>
// //         <li className="cursor-pointer" onClick={onNavigate.products}>
// //           Products
// //         </li>
// //         <li className="cursor-pointer" onClick={onNavigate.services}>
// //           Services
// //         </li>
// //         <li className="cursor-pointer" onClick={onNavigate.contact}>
// //           Contact
// //         </li>
// //       </ul>
// //     </nav>
// //   );
// // }

// import React from "react";
// import { colors } from "../Color";
// import logo from "../image/logo.jpg"; // Make sure this path and file are correct

// export default function Navbar({ onNavigate }) {
//   return (
//     <nav
//       className="flex justify-between items-center px-6 py-5 sticky top-0 z-50"
//       style={{ backgroundColor: colors.primary }}
//     >
//       {/* Logo Only */}
//       <div className="cursor-pointer" onClick={onNavigate.about}>
//         <img src={logo} alt="Hexa Logo" className="h-14 w-auto" />{" "}
//         {/* Adjust height if needed */}
//       </div>

//       {/* Navigation Links */}
//       <ul className="flex gap-6 text-white">
//         <li className="cursor-pointer" onClick={onNavigate.about}>
//           About
//         </li>
//         <li className="cursor-pointer" onClick={onNavigate.products}>
//           Products
//         </li>
//         <li className="cursor-pointer" onClick={onNavigate.services}>
//           Services
//         </li>
//         <li className="cursor-pointer" onClick={onNavigate.contact}>
//           Contact
//         </li>
//       </ul>
//     </nav>
//   );
// }

// import React from "react";
// import { colors } from "../Color";
// import logo from "../image/logo.png"; // Update path if needed

// export default function Navbar({ onNavigate }) {
//   return (
//     <nav
//       className="flex justify-between items-center px-6 h-28 sticky top-0 z-50"
//       style={{ backgroundColor: colors.background }}
//     >
//       {/* Logo */}
//       <div
//         className="cursor-pointer flex items-center"
//         onClick={onNavigate.about}
//       >
//         <img src={logo} alt="Hexa Logo" className="h-20" />
//       </div>

//       {/* Navigation Links */}
//       <ul
//         className="flex gap-6 items-center text-base font-medium"
//         style={{ color: colors.text }} // Set text color from your theme
//       >
//         <li className="cursor-pointer" onClick={onNavigate.about}>
//           About
//         </li>
//         <li className="cursor-pointer" onClick={onNavigate.products}>
//           Products
//         </li>
//         <li className="cursor-pointer" onClick={onNavigate.services}>
//           Services
//         </li>
//         <li className="cursor-pointer" onClick={onNavigate.contact}>
//           Contact
//         </li>
//       </ul>
//     </nav>
//   );
// }

///sidebar

// import React from "react";
// import { colors } from "../Color";
// import logo from "../image/logo.png"; // Update as needed

// // Simple burger icon component
// const BurgerIcon = ({ onClick }) => (
//   <button
//     onClick={onClick}
//     className="fixed top-4 left-4 z-60 flex flex-col gap-1.5"
//     aria-label="Toggle Sidebar"
//   >
//     {[...Array(3)].map((_, i) => (
//       <span key={i} className="block h-0.5 w-8 bg-white rounded" />
//     ))}
//   </button>
// );

// export default function Sidebar({
//   isOpen,
//   onClose,
//   toggleSidebar,
//   onNavigate,
// }) {
//   return (
//     <>
//       {/* Burger menu always visible */}
//       <BurgerIcon onClick={toggleSidebar} />

//       {/* Overlay background */}
//       {isOpen && (
//         <div
//           className="fixed inset-0 bg-black bg-opacity-50 z-50"
//           onClick={onClose}
//           aria-hidden="true"
//         />
//       )}

//       {/* Sidebar panel */}
//       <aside
//         className={`fixed top-0 left-0 h-full w-64 z-60 bg-[${
//           colors.background
//         }] transform transition-transform duration-300 ease-in-out
//           ${isOpen ? "translate-x-0" : "-translate-x-full"}`}
//         style={{ backgroundColor: colors.background }}
//       >
//         {/* Logo */}
//         <div
//           className="cursor-pointer mb-10 p-6 flex justify-center"
//           onClick={() => {
//             onNavigate.about();
//             onClose();
//           }}
//         >
//           <img src={logo} alt="Hexa Logo" className="h-20" />
//         </div>

//         {/* Navigation Links */}
//         <ul
//           className="space-y-6 text-lg font-semibold text-center"
//           style={{ color: colors.text }}
//         >
//           <li
//             className="cursor-pointer hover:underline"
//             onClick={() => {
//               onNavigate.about();
//               onClose();
//             }}
//           >
//             About
//           </li>
//           <li
//             className="cursor-pointer hover:underline"
//             onClick={() => {
//               onNavigate.ProductAndService();
//               onClose();
//             }}
//           >
//             Products & Services
//           </li>
//           <li
//             className="cursor-pointer hover:underline"
//             onClick={() => {
//               onNavigate.mission();
//               onClose();
//             }}
//           >
//             Mission
//           </li>
//           <li
//             className="cursor-pointer hover:underline"
//             onClick={() => {
//               onNavigate.contact();
//               onClose();
//             }}
//           >
//             Contact
//           </li>
//         </ul>
//       </aside>
//     </>
//   );
// }

/////new side bar

import React from "react";
import { colors } from "../Color";
import logo from "../image/logo.png";

// Simple burger icon component
const BurgerIcon = ({ onClick }) => (
  // <button
  //   onClick={onClick}
  //   className="fixed top-4 left-4 z-50 flex flex-col gap-1.5"
  //   aria-label="Toggle Sidebar"
  // >
  //   {[...Array(3)].map((_, i) => (
  //     <span key={i} className="block h-0.5 w-8 bg-white rounded" />
  //   ))}
  // </button>
  ///nw

  <button
    onClick={onClick}
    className="fixed top-4 left-4 z-50 flex flex-col gap-1.5 full p-3 "
    aria-label="Toggle Sidebar"
  >
    {[...Array(3)].map((_, i) => (
      <span
        key={i}
        // className="block h-0.5 w-8 rounded bg-white"
        className="block h-0.5 w-8 rounded bg-blue-600"
        // style={{ mixBlendMode: "overlay" }}
      />
    ))}
  </button>
);

export default function Sidebar({
  onNavigateTab,
  isOpen,
  onClose,
  toggleSidebar,
  onNavigate,
}) {
  return (
    <>
      {/* Burger menu always visible */}
      <BurgerIcon onClick={toggleSidebar} />

      {/* Overlay background */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={onClose}
          aria-hidden="true"
        />
      )}

      {/* Sidebar panel */}
      <aside
        className={`fixed top-0 left-0 h-full w-64 z-50 transform transition-transform duration-300 ease-in-out ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        }`}
        style={{ backgroundColor: colors.background }}
      >
        {/* Logo */}
        {/* <div
          className="cursor-pointer mb-10 p-6 flex justify-center"
          onClick={() => {
            onNavigate.about();
            onClose();
          }}
        >
          <img src={logo} alt="Hexa Logo" className="h-28" />
        </div> */}

        <div
          className="cursor-pointer mb-10 p-6 flex justify-center"
          onClick={() => {
            onNavigate.about();
            onClose();
          }}
        >
          <img src={logo} alt="Hexa Logo" className="h-28" />
        </div>

        {/* Navigation Links */}
        <ul
          className="space-y-6 text-lg font-semibold text-center"
          style={{ color: colors.text }}
        >
          <li
            className="cursor-pointer hover:underline"
            onClick={() => {
              onNavigate.about();
              onClose();
            }}
          >
            About
          </li>
          <li
            className="cursor-pointer hover:underline"
            onClick={() => onNavigateTab("product")}
          >
            Product
          </li>
          <li
            className="cursor-pointer hover:underline"
            onClick={() => {
              onNavigate.mission();
              onClose();
            }}
          >
            Mission
          </li>

          <li
            className="cursor-pointer hover:underline"
            onClick={() => {
              onNavigate.whychooseus();
              onClose();
            }}
          >
            Why Choose Us
          </li>

          <li
            className="cursor-pointer hover:underline"
            onClick={() => {
              onNavigate.contact();
              onClose();
            }}
          >
            Contact
          </li>
        </ul>
      </aside>
    </>
  );
}

///new
